import React from 'react';

import Header from '../partials/Header';
import Stats from '../partials/Stats';
import ContactUsPartial from '../partials/ContactUsPartial';
import Footer from '../partials/Footer';
import PlatformTabs from "../partials/PlatformTabs";

function Platform() {
    return (
    <div className="flex flex-col min-h-screen overflow-hidden bg-black">
        <Header />

        <main className="flex-grow relative">
            <div
                className="pointer-events-none absolute inset-0"
                aria-hidden="true"
                style={{
                    background:
                        'radial-gradient(circle at top left, rgba(59,130,246,0.20), transparent 55%),' +
                        'radial-gradient(circle at top right, rgba(23, 204, 224, 0.1), transparent 55%),' +
                        'radial-gradient(circle at bottom center, rgba(16,185,129,0.18), transparent 60%)',
                }}
            />

            <div className="relative">


                <PlatformTabs/>
                <Stats/>
                <ContactUsPartial/>
            </div>
        </main>

        <Footer/>
    </div>
    );
}

export default Platform;